import Link from "next/link";
import kebabCase from "@/utils/blog/kebabCase";
import { Text, chakra } from "@chakra-ui/react";

const Tag = ({ text }) => (
  <Text cursor="pointer" mt={3} mr={3} textTransform="uppercase" color="gray.500">
    {text.split(" ").join("-")}
  </Text>
);

export default Tag;
